import { render, staticRenderFns } from "./customizedServices.vue?vue&type=template&id=3d90a5b8&scoped=true&"
import script from "./customizedServices.vue?vue&type=script&lang=js&"
export * from "./customizedServices.vue?vue&type=script&lang=js&"
import style0 from "./customizedServices.vue?vue&type=style&index=0&id=3d90a5b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90a5b8",
  null
  
)

export default component.exports